const textFieldFormServiceQuesList = {
  comment: 'Comentário',
  
};

export default textFieldFormServiceQuesList;
